export enum AllotmentRetryTypeEnum {
  FLIGHTS = "FLIGHTS",
}
